import httpStatus from "http-status";
import { NextFunction, Request, Response } from "express";
import { catchAsync } from "../../utils/catchAsync";
import { sendResponse } from "../../utils/sendResponse";
import { postService } from "./post.service";

const createPost = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const id = req.user?.id;
    const payload = req.body;

    const result = await postService.createPost(payload, id as string);

    sendResponse(res, {
      success: true,
      statusCode: httpStatus.CREATED,
      message: "Post Created Successfully!",
      data: result,
    });
  },
);

const getAllPosts = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const posts = await postService.getAllPosts();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: {
        posts,
      },
    });
  },
);

// ? Filtering with Exact Match
const getAllPostsWithFilter = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const posts = await postService.getAllPostsWithFilter();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: {
        posts,
      },
    });
  },
);

// ? Search/Filtering with Partial Match
const getAllPostsWithSearch = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const posts = await postService.getAllPostsWithSearch();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: {
        posts,
      },
    });
  },
);

// ? Filtering with exact match (AND Operator) and Search with Partial Match (OR Operator)
const getAllPostsWithFilterAndSearch = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const posts = await postService.getAllPostsWithFilterAndSearch();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: {
        posts,
      },
    });
  },
);

// ? Filtering with exact match (AND Operator) and Search with Partial Match (OR Operator)
const getAllPostsWithPagination = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const posts = await postService.getAllPostsWithPagination();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: {
        posts,
      },
    });
  },
);

// ? Filtering with exact match (AND Operator) and Search with Partial Match (OR Operator)
const getAllPostsWithDynamicPagination = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const queryParams = req.query;
    // console.log(queryParams);
    const posts =
      await postService.getAllPostsWithDynamicPagination(queryParams);
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Retrieved Successfully!",
      data: posts.data,
      meta: posts.meta,
    });
  },
);

const getPostById = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const postId = req.params.postId;
    if (!postId) {
      throw new Error("Post Id required in params.");
    }

    const post = await postService.getPostById(postId as string);
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post retrieved Successfully!",
      data: post,
    });
  },
);

const getPostsStats = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const result = await postService.getPostsStats();
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post stats retrieved Successfully!",
      data: result,
    });
  },
);

const getMyPosts = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const authorId = req.user?.id;
    const post = await postService.getMyPosts(authorId as string);
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "My Post retrieved Successfully!",
      data: post,
    });
  },
);

const updatePost = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const postId = req.params.postId;
    const payload = req.body;
    const authorId = req.user?.id;
    const isAdmin = req.user?.role === "ADMIN";

    const result = await postService.updatePost(
      postId as string,
      payload,
      authorId as string,
      isAdmin,
    );
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post updated Successfully!",
      data: result,
    });
  },
);

const deletePost = catchAsync(
  async (req: Request, res: Response, next: NextFunction) => {
    const postId = req.params.postId;
    const authorId = req.user?.id;
    const isAdmin = req.user?.role === "ADMIN";

    if (!postId) {
      throw new Error("Post Id required in params.");
    }

    await postService.deletePost(postId as string, authorId as string, isAdmin);
    sendResponse(res, {
      success: true,
      statusCode: httpStatus.OK,
      message: "Post Deleted Successfully!",
      data: {},
    });
  },
);

export const postController = {
  createPost,
  getAllPosts,
  getAllPostsWithFilter,
  getAllPostsWithSearch,
  getAllPostsWithFilterAndSearch,
  getAllPostsWithPagination,
  getAllPostsWithDynamicPagination,
  getPostsStats,
  getMyPosts,
  getPostById,
  updatePost,
  deletePost,
};
